export default __webpack_public_path__ + "static/media/favicon.42cf1b2a.ico";